import { createContext } from "preact";
import { experiment1, experiment2 } from "./data";
import { retry } from "./retry";
export function getGroup() {
    // EITHER: take the one in the url param, saved, or randomize
    const CONTROL_CHANCE = 0.5;
    const parsedUrl = new URL(window.location.href);
    const deobf = (param) => param.charCodeAt(0) % 2 === 1 ? "control" : "experiment";
    const searchMay = parsedUrl.searchParams.get("g");
    const ret = (searchMay
        ? deobf(searchMay)
        : window.localStorage.getItem("activeGroup")) ??
        (Math.random() < CONTROL_CHANCE ? "control" : "experiment");
    window.localStorage.setItem("activeGroup", ret);
    return ret;
}
export function getParticipantId() {
    function make() {
        const arr = new Uint32Array(1);
        window.crypto.getRandomValues(arr);
        return arr[0];
    }
    const existing = window.localStorage.getItem("participant");
    const value = existing ? parseInt(existing) : make();
    window.localStorage.setItem("participant", value.toString());
    return value;
}
export const CurrentGroup = createContext("control");
export const Observer = createContext(null);
export class ExperimentObserver {
    group;
    participant;
    constructor(group, participant) {
        this.group = group;
        this.participant = participant;
    }
    selectedExperiment() {
        // The first experiment is selected from the two experiment definitions
        // (task list, etc) at random. There are four possibilities:
        // part. id | group    |  exp def
        // even       control     1
        // even       experiment  2
        // odd        control     2
        // odd        experiment  1
        const partIdIsEven = this.participant % 2 === 0;
        if (partIdIsEven) {
            switch (this.group) {
                case "control":
                    return experiment1;
                case "experiment":
                    return experiment2;
            }
        }
        else {
            switch (this.group) {
                case "control":
                    return experiment2;
                case "experiment":
                    return experiment1;
            }
        }
    }
    async observe(meta) {
        const id = new BigUint64Array(1);
        window.crypto.getRandomValues(id);
        const obs = {
            group: this.group,
            participant: this.participant,
            meta,
            timestamp: Date.now(),
            idempotencyKey: id[0].toString(),
        };
        console.log("Observe", meta);
        const doIt = () => fetch("/observe", {
            method: "POST",
            cache: "no-cache",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(obs),
        }).then((r) => {
            if (r.ok) {
                return r;
            }
            throw new Error(`http not ok: ${r.status} ${r.statusText}`);
        });
        await retry(doIt, () => { }, 20);
    }
}
